var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-custom-overlays-separator",class:{
    '-no-label': !_vm.field.label,
    '-expendable': _vm.field.__expendable,
    '-expend': _vm.field.__expend,
  },on:{"click":function($event){return _vm.$emit('emmiter', { name: 'toggle-expend', data: _vm.field })}}},[(_vm.field.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.field.label)}}):_vm._e(),_vm._v(" "),_vm._t("tooltip"),_vm._v(" "),(_vm.field.__expendable)?_c('i',{staticClass:"wticon wticon-angle-left",class:_vm.field.__expend ? 'rotate-up' : 'rotate-down'}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }